// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pfKrE{0%{background-color:#fcfcfd}30%{background-color:#f3f5ff}70%{background-color:#f3f5ff}100%{background-color:#fcfcfd}}@keyframes NXqVA{0%{background-color:transparent}50%{background-color:#dae0ff}100%{background-color:transparent}}.Jktd5{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 16px);box-sizing:border-box;inline-size:100%;color:#696992;flex-shrink:0;align-items:stretch}.Jktd5 .OOeMd{align-items:stretch;border:0}.FdWil{background:#fcfcfd;box-shadow:0px 4px 12px rgba(40,40,99,.06);border-radius:4px;transition:box-shadow .2s}.FdWil.M7BdN{border-color:#6942f8}.FdWil.BRYkn{animation:pfKrE 4s}.FdWil:hover,.FdWil.OkoWA,.FdWil.M7BdN{box-shadow:0px 4px 14px rgba(40,40,99,.24)}.FdWil:hover.AeulU,.FdWil.OkoWA.AeulU,.FdWil.M7BdN.AeulU{box-shadow:0px 4px 12px rgba(40,40,99,.06)}.FdWil:not(:last-child){margin-bottom:8px}.FdWil:first-child{margin-top:2px}.FdWil:focus-within .BXH8J,.FdWil:hover .BXH8J{visibility:visible;opacity:1}.FdWil:focus-within .BPa9J,.FdWil:hover .BPa9J{visibility:hidden;opacity:0}.fpOEJ{background:transparent;border:0}.fpOEJ.BRYkn{animation:NXqVA 2s}.fpOEJ:first-child{margin-top:26px}.fpOEJ:not(:last-child):not(.fiZG_){margin-bottom:32px}.fpOEJ.du27P:hover{background:#f3f5ff}.OOeMd{color:#696992;width:100%;display:flex;align-items:center;gap:8px}.OOeMd.I1ki_{padding:0 24px}.OOeMd.CDP4Z{padding:0 4px}.OOeMd[disabled]{cursor:default;pointer-events:none}.wshOL{border-radius:4px;background:#fcfcfd}.wshOL.EU8Tt{height:52px}.wshOL.E05S8{height:56px}.wshOL.JTxuu{height:fit-content;min-height:52px;padding-top:4px;padding-bottom:4px}.s4cig{background:transparent}.s4cig.RLG7J{height:24px}.s4cig.EU8Tt{height:40px}.s4cig.E05S8{height:56px}.JLiir{margin:0 24px;height:1px;background:#d4d4e0}.uKmbk{cursor:pointer}.ZyJOK{font-family:"Lufga-Regular";font-weight:400;color:#696992;font-size:var(--font-size-p2, 14px);box-sizing:border-box;display:flex;align-items:center;gap:8px;border-radius:4px;width:fit-content;min-width:100%;flex-shrink:0;z-index:2}.ZyJOK.BL6cQ{block-size:32px}.ZyJOK.yLS90{block-size:28px}.ZyJOK.I1ki_{padding-inline:24px}.ZyJOK.CDP4Z{padding-inline:4px}.ZyJOK.XJ11I{background-color:#eaeaef}.ZyJOK.JqzaH{background-color:#d4d4e0}.ZyJOK.Y8J5M{background-color:transparent}.ZyJOK.WiWsv{position:sticky;top:0}.ZyJOK .Osah4{font-family:"Lufga-Regular";font-weight:400;color:#696992;font-size:var(--font-size-p2, 14px);display:flex;align-items:center;gap:8px;border:0;padding:0;background:inherit;cursor:pointer;text-align:start}.ZyJOK .Q5eB3{color:#282863}.yM1n0{display:flex;align-items:center;gap:16px;flex:1;height:100%}.E0u4m{display:flex;gap:16px;flex:1;align-self:stretch}.BXH8J{visibility:hidden;opacity:0;transition:visibility .2s,opacity .2s}.BPa9J{visibility:visible;opacity:1;transition:visibility .2s,opacity .2s}.Hyvzq{visibility:visible !important;opacity:1 !important}.kSX9r{min-width:8px}.W1EF8{height:100%;display:flex;align-items:center;gap:16px}.W1EF8.I1ki_{padding-right:24px}.W1EF8.CDP4Z{padding-right:4px}.Bsb57{height:100%;display:flex;align-items:center;gap:16px;position:sticky;left:0;z-index:1;background:inherit}.Bsb57.I1ki_{margin:auto 0;padding-left:24px;margin-left:-24px;padding-right:8px}.Bsb57.CDP4Z{padding-left:4px;margin-left:-4px;padding-right:8px}.d0SGT{overflow:auto;display:inline-block}.Ophzs{height:auto;display:flex;align-items:center;position:sticky;right:0;top:0;bottom:0;z-index:1;justify-content:flex-end;background:inherit}.Ophzs.I1ki_{padding-right:24px;margin-right:-24px;padding-left:8px}.Ophzs.CDP4Z{padding-right:4px;margin-right:-4px;padding-left:4px}.KV52e{height:100%;display:flex;flex-direction:column;overflow:auto}.fbJ1L{flex:1;margin-top:8px}.fbJ1L.pdb0L>*{width:fit-content;min-width:100%}.DNkrK{justify-content:space-between}.DWEwx{margin-bottom:8px}.DT35m{flex-shrink:0}.cCyzw{flex:1;overflow:hidden}.bm83q{display:flex;align-items:baseline;gap:4px;padding:4px 0}.aj6Yw{flex-shrink:0}.KCxTh{justify-content:space-between}.YoJxv{flex:1;min-width:0}.KCxTh .YoJxv{flex:unset}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 48px)`,
	"fontSizeH2": `var(--font-size-h2, 40px)`,
	"fontSizeH3": `var(--font-size-h3, 33px)`,
	"fontSizeH4": `var(--font-size-h4, 28px)`,
	"fontSizeH5": `var(--font-size-h5, 22px)`,
	"fontSizeH6": `var(--font-size-h6, 20px)`,
	"fontSizeP1": `var(--font-size-p1, 16px)`,
	"fontSizeP2": `var(--font-size-p2, 14px)`,
	"fontSizeP3": `var(--font-size-p3, 12px)`,
	"lineHeightH1": `var(--line-height-h1, 64px)`,
	"lineHeightH2": `var(--line-height-h2, 56px)`,
	"lineHeightH3": `var(--line-height-h3, 40px)`,
	"lineHeightH4": `var(--line-height-h4, 40px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 35px)`,
	"lineHeightP1": `var(--line-height-p1, 24px)`,
	"lineHeightP2": `var(--line-height-p2, 18px)`,
	"lineHeightP3": `var(--line-height-p3, 16px)`,
	"row": `Jktd5`,
	"rowInner": `OOeMd`,
	"defaultRowVariant": `FdWil`,
	"selected": `M7BdN`,
	"pulse": `BRYkn`,
	"row-pulse": `pfKrE`,
	"hover": `OkoWA`,
	"disableShadow": `AeulU`,
	"showOnRowHover": `BXH8J`,
	"hideOnRowHover": `BPa9J`,
	"minimalRowVariant": `fpOEJ`,
	"row-pulse-minimal": `NXqVA`,
	"disableMarginBottom": `fiZG_`,
	"highlightOnHover": `du27P`,
	"mPadding": `I1ki_`,
	"xsPadding": `CDP4Z`,
	"defaultRowInnerVariant": `wshOL`,
	"mediumRowSize": `EU8Tt`,
	"largeRowSize": `E05S8`,
	"fluidRowSize": `JTxuu`,
	"minimalRowInnerVariant": `s4cig`,
	"smallRowSize": `RLG7J`,
	"separator": `JLiir`,
	"clickable": `uKmbk`,
	"header": `ZyJOK`,
	"mediumSize": `BL6cQ`,
	"smallSize": `yLS90`,
	"grayBg": `XJ11I`,
	"darkGrayBg": `JqzaH`,
	"transparentBg": `Y8J5M`,
	"stickyToTop": `WiWsv`,
	"sortable": `Osah4`,
	"sortActive": `Q5eB3`,
	"headerItemData": `yM1n0`,
	"rowItemData": `E0u4m`,
	"showAlways": `Hyvzq`,
	"sortIcons": `kSX9r`,
	"stickyCheckbox": `W1EF8`,
	"stickyCheckboxWrapper": `Bsb57`,
	"expandedContent": `d0SGT`,
	"rowActionSticky": `Ophzs`,
	"container": `KV52e`,
	"containerContent": `fbJ1L`,
	"hasHorizontalScroll": `pdb0L`,
	"justifyBetween": `DNkrK`,
	"mobileCard": `DWEwx`,
	"mobileActions": `DT35m`,
	"mobileRowBeforeActions": `cCyzw`,
	"mobileCardRow": `bm83q`,
	"mobileCardRowLabel": `aj6Yw`,
	"spaceBetween": `KCxTh`,
	"mobileCardRowValue": `YoJxv`
};
export default ___CSS_LOADER_EXPORT___;
